/* eslint-disable import/no-anonymous-default-export */
import API from 'services/API';

export const get = () => API.get('/userRole');
